import {
  GetGrowthWheelByRoleIdDto,
  GetGrowthWheelByUserIdDto,
  GrowthWheel,
  CompetencyArea,
  UpdateCompetencyEvaluationDto,
  UpdateCompetencyEvaluationPayload,
} from '../types/GrowthWheel'
import { timeoffApi } from './timeoff.api'

export interface CompetencyEvaluationResponse {
  id: number
  selfLevel: number | null
  selfNote: string | null
  leaderLevel: number | null
  leaderNote: string | null
  focus: boolean
}

export interface GrowthWheelUserForReview {
  id: number
  firstName: string
  lastName: string
  email: string
  area: string
  evaluationsDone: number
  totalEvaluations: number
  guildId: number
}

const growthWheelEndpoints = timeoffApi.injectEndpoints({
  endpoints: build => ({
    getAllGrowthWheels: build.query<GrowthWheel[], void>({
      query: () => `/growth-wheel`,
      providesTags: ['GrowthWheelData'],
    }),
    getGrowthWheelByRoleId: build.query<GrowthWheel, GetGrowthWheelByRoleIdDto>({
      query: query =>
        `/growth-wheel/role/${query.roleId}`,
      providesTags: ['GrowthWheelData'],
    }),
    getGrowthWheelWithEvaluationsByUserId: build.query<
      CompetencyArea[],
      GetGrowthWheelByUserIdDto
    >({
      query: query => `/growth-wheel/user/${query.userId}/competency-evaluations`,
      providesTags: ['GrowthWheelData'],
    }),
    getGrowthWheelUsersByGrowthWheelReviewerId: build.query<GrowthWheelUserForReview[], { reviewerId: number }>({
      query: query => `/growth-wheel/reviewer/${query.reviewerId}/users`,
      providesTags: ['GrowthWheelData'],
    }),
    updateCompetencyEvaluation: build.mutation<
      CompetencyEvaluationResponse,
      UpdateCompetencyEvaluationDto
    >({
      query: ({ evaluationId, payload }) => ({
        url: `/growth-wheel/competency-evaluation/${evaluationId}`,
        method: 'PATCH',
        body: payload,
      }),
      invalidatesTags: ['GrowthWheelData'],
    }),
  }),
})

export const {
  useGetAllGrowthWheelsQuery,
  useGetGrowthWheelByRoleIdQuery,
  useGetGrowthWheelWithEvaluationsByUserIdQuery,
  useGetGrowthWheelUsersByGrowthWheelReviewerIdQuery,
  useUpdateCompetencyEvaluationMutation,
} = growthWheelEndpoints

export type { UpdateCompetencyEvaluationPayload }
